<template>
  <div
    class="base-text"
    :class="customClass"
    :style="customStyle"
    @click="$emit('click')"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseText',
  props: {
    size: {
      type: String,
      default: '',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    nowrap: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    semibold: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
    underline: {
      type: Boolean,
      default: false,
    },
    trim: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [Number, String],
      default: null,
    },
    breakWord: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    customStyle() {
      const styles = {};

      if (this.trim) {
        styles['max-width'] = `${this.maxWidth}px`;
      }

      return styles;
    },
    customClass() {
      const customClass = {
        [`base-text--${this.size}`]: true,
        'base-text--nowrap': this.nowrap,
        'base-text--light': this.light,
        'base-text--inline-block': this.inline && this.block,
        'base-text--inline': this.inline && !this.block,
        'base-text--block': this.block && !this.inline,
        'base-text--bold': this.bold,
        'base-text--semibold': this.semibold,
        'base-text--regular': this.regular,
        'base-text--medium': this.medium,
        'base-text--muted': this.muted,
        'base-text--uppercase': this.uppercase,
        'base-text--underline': this.underline,
        'base-text--trim': this.trim,
        'base-text--break-word': this.breakWord,
      };
      return customClass;
    },
  },
};
</script>

<style lang="scss" scoped>
.base-text {
//TODO: these should be changed to accommodate Figma

  &--xxs {
    font-size: $font-size-xxs;
  }
  //8px
  &--xs {
    font-size: $font-size-xs;
    //9.47px
  }
  //need 10px, 11px
  &--s {
    font-size: $font-size-s;
  }
  //12px
  &--md {
    font-size: $font-size-md;
  }
  //13px
  &--m {
    font-size: $font-size-m;
  }
  &--l {
    font-size: $font-size-l;
  }
  //20px
  &--lg {
    font-size: $font-size-lg;
  }
  //22px
  &--light {
    font-family: $font-family-sans-serif-light;
  }
  &--bold {
    font-family: $font-family-sans-serif-bold;
  }
  &--semibold {
    font-family: $font-family-sans-serif-semibold;
  }
  &--regular {
    font-family: $font-family-sans-serif-regular;
  }
  &--medium {
    font-family: $font-family-sans-serif-medium;
  }
  &--nowrap {
    white-space: nowrap;
  }
  &--inline {
    display: inline;
  }
  &--block {
    display: block;
  }
  &--inline-block {
    display: inline-block;
  }
  &--muted {
    color: $text-muted-color;
  }
  &--uppercase {
    text-transform: uppercase;
  }
  &--underline {
    // text-decoration: underline;
    border-bottom: solid 1px $black;
  }
  &--trim {
    text-overflow: ellipsis;
    overflow:hidden;
    white-space:nowrap;
  }
  &--break-word {
    word-wrap: break-word;
  }
}
</style>
